import {
  AlignLeft2Line,
  BarchartFilled,
  CalendarDatesFilled,
  CheckFilled,
  Comment2QuestionFilled,
  Dashboard2Filled,
  DiscordBrand,
  DollarLine,
  EmailFilled,
  ExternalLinkLine,
  FileUploadFilled,
  GearFilled,
  Link1Line,
  Link2Filled,
  QuestionLine,
  ShieldLine,
  SortNumberLine,
  TelegramBrand,
  TicketFilled,
  TiktokBrand,
  TrophyFilled,
  TwitterFilled,
  UserArrowRightFilled,
  WalletConnectBrand,
} from '@zealy/icons';

export const TASK_ICONS = {
  token: DollarLine,

  nft: TicketFilled,

  onChain: Link2Filled,

  partnership: UserArrowRightFilled,

  partnershipQuest: TrophyFilled,

  file: FileUploadFilled,

  image: FileUploadFilled,

  discord: DiscordBrand,

  telegram: TelegramBrand,

  twitter: TwitterFilled,

  tweet: TwitterFilled,

  tweetReact: TwitterFilled,

  twitterSpace: TwitterFilled,

  twitterFollow: TwitterFilled,

  twitterBlue: TwitterFilled,

  poll: BarchartFilled,

  quiz: Comment2QuestionFilled,

  opinion: Dashboard2Filled,

  text: AlignLeft2Line,

  date: CalendarDatesFilled,

  number: SortNumberLine,

  url: Link1Line,

  visitLink: ExternalLinkLine,

  invites: EmailFilled,

  api: GearFilled,

  default: QuestionLine,

  wallet: WalletConnectBrand,

  tiktok: TiktokBrand,

  proveYourHumanity: ShieldLine,
} as const;

export type QuestTypeMappedKey = keyof typeof TASK_ICONS;
